import './SideBar.scss'

const Sidebar = (props) => {
    const componentClass = 'smart-modals-sidebar'

    return <div className={componentClass}>{props.children}</div>
}

export default Sidebar
